// extracted by mini-css-extract-plugin
module.exports = {"productpage":"productpage_productpage__2WbgN","showcase":"productpage_showcase__1zhr9","subTitle":"productpage_subTitle__1ry9x","title":"productpage_title__2JVrp"};